var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "designs--foreground", attrs: { id: "blog" } },
    [
      _c(
        "section",
        { staticClass: "section section--posts-filter text-center mt-5" },
        [
          _c("div", { staticClass: "container container--grid" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 filters" }, [
                _c("div", { staticClass: "filter__label" }, [
                  _vm._v("Sort By")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "filter__options" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "select-field filter-select-field js-select-field form-group mb-3 mb-md-0"
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters.categories.current,
                              expression: "filters.categories.current"
                            }
                          ],
                          attrs: {
                            name: "categories",
                            "data-select": _vm.categories
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.filters.categories,
                                  "current",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              _vm.filter
                            ]
                          }
                        },
                        [
                          _c("option", {
                            attrs: { value: "all", selected: "" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.filters.categories.placeholder
                              )
                            }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.filters.categories.terms, function(term) {
                            return _c("option", {
                              domProps: {
                                value: term.slug,
                                innerHTML: _vm._s(term.name)
                              }
                            })
                          })
                        ],
                        2
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("section", { staticClass: "section section--posts-grid mt-0" }, [
        _c("div", { staticClass: "container container--grid" }, [
          _vm.searching
            ? _c("div", { staticClass: "row" }, [_vm._m(0)])
            : _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.posts, function(post) {
                  return post.key % 4 == 0
                    ? _c("div", { staticClass: "col-12" }, [
                        _c(
                          "a",
                          {
                            staticClass: "card card--wide",
                            attrs: {
                              href: post.custom.link,
                              title: post.post_title
                            }
                          },
                          [
                            _c("div", { staticClass: "card__inner" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c("div", { staticClass: "col-12 col-md-8" }, [
                                  post.custom.image.image
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "card__image background-image",
                                          style: {
                                            backgroundImage:
                                              "url('" +
                                              post.custom.image.image +
                                              "')"
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "sr-only",
                                            attrs: {
                                              src: post.custom.image.image,
                                              alt: ""
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c("div", { staticClass: "card__content" }, [
                                    _c("h3", {
                                      staticClass: "card__title",
                                      domProps: {
                                        innerHTML: _vm._s(post.post_title)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "card__excerpt",
                                      domProps: {
                                        innerHTML: _vm._s(post.custom.excerpt)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "card__link" }, [
                                      _c("span", {
                                        staticClass: "card__link-text",
                                        domProps: {
                                          innerHTML: _vm._s(post.card_link)
                                        }
                                      })
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]
                        )
                      ])
                    : _c(
                        "a",
                        {
                          staticClass: "col-12 col-md-4 card card--col",
                          attrs: { href: post.custom.link }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card__inner",
                              attrs: { title: post.post_title }
                            },
                            [
                              post.custom.image.image
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card__image background-image",
                                      style: {
                                        backgroundImage:
                                          "url('" +
                                          post.custom.image.image +
                                          "')"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "sr-only",
                                        attrs: {
                                          src: post.custom.image.image,
                                          alt: ""
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "card__content" }, [
                                _c("h3", {
                                  staticClass: "h3--xs card__title",
                                  domProps: {
                                    innerHTML: _vm._s(post.post_title)
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "card__excerpt",
                                  domProps: {
                                    innerHTML: _vm._s(post.custom.excerpt)
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "card__link" }, [
                                _c("span", {
                                  staticClass: "card__link-text",
                                  domProps: {
                                    innerHTML: _vm._s(post.card_link)
                                  }
                                })
                              ])
                            ]
                          )
                        ]
                      )
                }),
                0
              ),
          _vm._v(" "),
          _vm.noResults
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 text-center" }, [
                  _vm._v("\n          " + _vm._s(_vm.noResults) + "\n        ")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasPagination
            ? _c(
                "div",
                { staticClass: "row mt-6", attrs: { "animate-up": "" } },
                [
                  _c(
                    "div",
                    { staticClass: "col-12 text-center" },
                    [
                      !_vm.isLoadingNextPage
                        ? _c("button", {
                            staticClass: "btn btn--solid btn--grey-blue-light",
                            attrs: { type: "button" },
                            domProps: {
                              innerHTML: _vm._s(_vm.pagination.label)
                            },
                            on: { click: _vm.loadMoreTrigger }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isLoadingNextPage
                        ? _c("infinite-loading", {
                            ref: "infiniteLoading",
                            staticClass: "pagination js-load-more-pagination",
                            attrs: { identifier: _vm.infiniteId },
                            on: { infinite: _vm.loadMoreHandler }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 text-center filters__searching" }, [
      _c("div", { staticClass: "spinner" }, [
        _c("div", { staticClass: "bounce1" }),
        _vm._v(" "),
        _c("div", { staticClass: "bounce2" }),
        _vm._v(" "),
        _c("div", { staticClass: "bounce3" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "filters__searching-text sm" }, [
        _vm._v("Searching...")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /builds/hatchet/creativemazes/wp-content/themes/creative-mazes-theme/node_modules/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"js":"babel-loader"}}!/builds/hatchet/creativemazes/wp-content/themes/creative-mazes-theme/node_modules/vue-loader/lib?{"loaders":{"js":"babel-loader"}}!./scripts/vue/Blog/Blog.vue?vue&type=template&id=a5fd3aea&
// module id = 48
// module chunks = 0